<template>
  <slick ref="slick" :options="slickOptions">
    <div v-for="(content, index) in this.contents" :key="index">
      <div class="sg-card">
        <img
          :src="require('@/assets/img/testimonial/' + content.img)"
          class="testimonial-photo"
        />
        <div class="sg-card-body">
          <h4>
            {{ content.name }}
          </h4>
          <h6>
            {{ content.who }}
          </h6>
          <p style="font-size: 14px; margin-top: 1em;">
            &quot;{{ content.text }}&quot;
          </p>
        </div>
      </div>
    </div>
  </slick>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Carousel_Testimonial',
  props: ['contents', 'vertical', 'slidesToShow'],
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        // options can be used from the plugin documentation
        speed: 500,
        autoplay: true,
        infinite: true,
        slidesToShow: this.slidesToShow,
        slidesToScroll: 1,
        vertical: this.vertical,
        prevArrow: '',
        nextArrow: ''
      }
    }
  },
  methods: {
    /* vue slick prerequisites */
    next: function () {
      this.$refs.slick.next()
    },
    prev: function () {
      this.$refs.slick.prev()
    },
    reInit: function () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick()
    }
    /* END vue slick prerequisites */
  }
}
</script>

<style scoped>
  .sg-card {
    margin: 0 auto;
    width: 90%;
  }
  @media screen and (max-width: 767px) {
    .sg-card {
      height: 22em;
    }
  }
  @media screen and (max-width: 1023px) and (min-width: 768px) {
    .sg-card {
      height: 22em;
    }
  }
  @media screen and (min-width: 1023px) {
    .sg-card {
      height: 22em;
    }
  }

  .sg-card-body {
    background-color: white;
    border-radius: 15px;

    margin-top: -3em;
    padding: 4em 1em 1em 1em;
  }
  @media screen and (max-width: 767px) {
    .sg-card-body {
      height: 18em;
    }
  }
  @media screen and (max-width: 1023px) and (min-width: 768px) {
    .sg-card-body {
      height: 18.5em;
    }
  }
  @media screen and (min-width: 1023px) {
    .sg-card-body {
      height: 19em;
    }
  }

  .testimonial-photo {
    border-radius: 50%;
    margin: 0 auto;
    max-width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Carousel/Testimonial/Testimonial.vue